import ViewerDialog from './ViewerDialog';

export default ViewerDialog;
